// Helpers for the /work filter chips.
//
// The groups themselves are content now — "Filter groups" in the Studio, ordered
// on the Work page — so these take the group list as an argument rather than
// owning it. What stays here is the slug logic, because it defines the ?c= URL
// and must not change when someone renames a chip in the CMS.

export const labelToSlug = (label) =>
  String(label ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const slugToLabel = (slug, groups = []) =>
  groups.find((g) => labelToSlug(g.label) === slug)?.label ?? null;

// A project's categories, as plain titles. Tolerates a single value.
export const projectCats = (project) => [project?.categories ?? []].flat().filter(Boolean);

export const groupCats = (label, groups = []) =>
  groups.find((g) => g.label === label)?.cats ?? [];

// The chip a project belongs under — the first one that claims any of its
// categories. Used for the back link on a project page.
export const categoryToGroup = (project, groups = []) => {
  const cats = projectCats(project);
  return groups.find((g) => (g.cats ?? []).some((c) => cats.includes(c)))?.label ?? null;
};
